// noinspection JSDeprecatedSymbols
const getVendor = (): string => navigator.vendor;

export default getVendor;